module.exports = __webpack_public_path__ + "static/media/contentGlobe.faab48ca.svg";